import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { useAluno } from "@/hooks/alunos";
import { AlunoProvider } from "@/context/alunos/aluno";
import { Page, DashboardContainer } from "@/components/Grid";
import { FullPageLoader } from "@/components/Common";
import { Navbar } from "@/components/Blocks";

import { Sidebar, SubMenu, Transacoes, ContaBancaria } from "@/components/Aluno";

import {
  PaineisContainer,
  Content,
  MenuInterno,
  PainelPrincipal,
} from "./styles";

function _Financeiro({ history }) {
  const { data: user } = useSelector(state => state.auth);
  const { fetchAluno, aluno } = useAluno();
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    fetchAluno(user.perfil_id)
  }, [user]);

  return (
    <Page>
      <Navbar type="interna" />
      {!aluno && <FullPageLoader />}
      {aluno && (
        <>
          <DashboardContainer>
            <PaineisContainer>
              <Sidebar />
              <Content>
                <MenuInterno>
                  <SubMenu type="financeiro" />
                </MenuInterno>
                <PainelPrincipal>
                  <h1>Financeiro</h1>
                  <Tabs
                    forceRenderTabPanel={true}
                    selectedIndex={tabIndex}
                    onSelect={index => setTabIndex(index)}
                  >
                    <TabList>
                      <Tab>Recebimentos</Tab>
                      <Tab>Conta Bancária</Tab>
                    </TabList>
                    <TabPanel>
                      <Transacoes />
                    </TabPanel>
                    <TabPanel>
                      <ContaBancaria />
                    </TabPanel>
                  </Tabs>
                </PainelPrincipal>
              </Content>
            </PaineisContainer>
          </DashboardContainer>
        </>
      )}
    </Page>
  );
}

export default function Financeiro(props) {
  return (
    <AlunoProvider>
      <_Financeiro {...props} />
    </AlunoProvider>
  );
}
